import {PAGE_FETCHED, META_FETCHED, LOADED} from "../types";
import api from "../api";

export const pageFetched = page => ({
    type: PAGE_FETCHED,
    page
});
export const pageLoaded = loaded => ({
    type: LOADED,
    loaded
});

export const metaFetched = meta => ({
    type: META_FETCHED,
    meta
});


export const fetchedPage = (pageUrl) => (dispatch, getState) =>
  api.pages.fetchPage(pageUrl).then(res => {
      dispatch(pageFetched(res));
      dispatch(pageLoaded({'loaded' : true}))
  })

export const loadPage = () => (dispatch, getState) => {
    dispatch(pageLoaded({'loaded' : false}))
}







// WEBPACK FOOTER //
// ./src/actions/page.js